const ADMIN_EMAILS = ['admin@smartprompt.ai', 'demo@smartprompt.ai', 'pavlo.kosmos@gmail.com'];

export const isAdminEmail = (email?: string | null): boolean => {
  if (!email) return false;
  const lowerEmail = email.toLowerCase();
  return ADMIN_EMAILS.includes(lowerEmail) || lowerEmail.endsWith('@smartprompt.ai');
};

export const isAdminUser = (
  user?: { email?: string | null } | null,
  environment: string = import.meta.env.MODE
): boolean => {
  if (!user?.email) return environment === 'development';

  if (environment === 'development') {
    return true;
  }

  return isAdminEmail(user.email);
};
